import HttpBaseUrl from "../httpservice/common.http.js";
import axios from "axios";
import worker from "./../app.worker.js";
import WebWorker from "./../WebWorker.js";

// init webworker
let webWorker = new WebWorker(worker);

const headerNoAuth = {
  Accept: "application/json",
  "Content-Type": "application/json",
  "Access-Control-Allow-Origin": "*",
};

const getLatestPost = async () => {
  let utm_source = localStorage.getItem("utm_source");
  let langType = localStorage.getItem("language");
  const latestPostApi = `${HttpBaseUrl.getBaseUrl()}/articles/latest/home/setting/${
    langType ? langType : 1
  }/${utm_source ? utm_source : "Seekapeek"}?page=0&size=10`;
  const latestResponse = await axios.get(latestPostApi, {
    header: headerNoAuth,
  });

  if (latestResponse.status == 200) {
    let latestAllDataResult = latestResponse.data;

    const randomArray = (shuffleArray) => {
      for (let i = shuffleArray.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = shuffleArray[i];
        shuffleArray[i] = shuffleArray[j];
        shuffleArray[j] = temp;
      }
      return shuffleArray;
    };
    // latest category data
    randomArray(latestAllDataResult.content);
    let latestCategory = randomArray(latestAllDataResult);
    return latestCategory;
  }
};

function adRenderLogic(
  adApiDataRes,
  locationId,
  gptAdId,
  alternativeDivRequest
) {
  let utmSource = localStorage.getItem("utm_source");
  if (!utmSource) {
    utmSource = "Seekapeek";
  }

  if (adApiDataRes.body_tag) {
    // check whitespace
    if (adApiDataRes.body_tag.trim()=="") {
      return false;
    }
    let extractAdsBody = adApiDataRes.body_tag.trim();
    let adSense = "";
    let createAdsDiv = document.createElement("div");
    createAdsDiv.innerHTML = extractAdsBody;
    let adsBodyTag = createAdsDiv.firstChild;
    try {
      adSense = adsBodyTag.getAttribute("class");
    } catch (error) {}

    // checking ads platform
    if (adSense === "adsbygoogle") {
      let warpHeadHtmlString = document.createElement("div");
      warpHeadHtmlString.innerHTML = adApiDataRes.head_tag.trim();
      let adsenceHeadTag = warpHeadHtmlString.firstChild;
      let headerScriptIsExists = "";

      headerScriptIsExists = document.querySelector(
        "[src='" + adsenceHeadTag.getAttribute("src") + "']"
      );

      if (headerScriptIsExists === null || headerScriptIsExists === undefined) {
        var headScript = document.createElement("script");
        headScript.src = adsenceHeadTag.getAttribute("src");
        headScript.crossOrigin = adsenceHeadTag.getAttribute("crossorigin");
        headScript.async = true;
        document.head.appendChild(headScript);
      }

      var ins = document.createElement("ins");
      let classAttr = adsBodyTag.getAttribute("class");
      let styleAttr = adsBodyTag.getAttribute("style");
      let clientAttr = adsBodyTag.getAttribute("data-ad-client");
      let slotAttr = adsBodyTag.getAttribute("data-ad-slot");
      let formatAttr = adsBodyTag.getAttribute("data-ad-format");
      let responsiveAttr = adsBodyTag.getAttribute(
        "data-full-width-responsive"
      );
      if (classAttr) {
        ins.setAttribute("class", classAttr);
      }
      if (styleAttr) {
        ins.setAttribute("style", styleAttr);
      }
      if (clientAttr) {
        ins.setAttribute("data-ad-client", clientAttr);
      }
      if (slotAttr) {
        ins.setAttribute("data-ad-slot", slotAttr);
      }
      if (formatAttr) {
        ins.setAttribute("data-ad-format", formatAttr);
      }
      if (responsiveAttr) {
        ins.setAttribute("data-full-width-responsive", responsiveAttr);
      }

      if (alternativeDivRequest == true) {
        let suffix = "_other";
        let loactionDivPrevious = document.getElementById(locationId);

        // make id fo different solts div
        if (loactionDivPrevious.innerHTML) {
          let insDivPrevious = loactionDivPrevious.querySelector("ins");
          let dataAdAttributePrevious =
            insDivPrevious.getAttribute("data-ad-status");
          // dataAdAttributePrevious = "filled";

          if (dataAdAttributePrevious == "filled") {
            locationId = `${locationId}${suffix}`;
            document.getElementById(locationId).appendChild(ins);
            (window.adsbygoogle = window.adsbygoogle || []).push({});
          } else {
            loactionDivPrevious.innerHTML = "";
            document.getElementById(locationId).appendChild(ins);
            (window.adsbygoogle = window.adsbygoogle || []).push({});
          }
        } else {
          document.getElementById(locationId).appendChild(ins);
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        }

        // check current request is fill or un-fill
        setTimeout(() => {
          let loactionDiv = document.getElementById(locationId);
          let insDiv = loactionDiv.querySelector("ins");
          let dataAdAttribute = insDiv.getAttribute("data-ad-status");
          // dataAdAttribute = "filled";

          let tempLocationId = null;
          // check append div
          if (loactionDiv.innerHTML) {
            if (dataAdAttribute == "filled") {
              if (locationId.includes(suffix)) {
                tempLocationId = locationId.split(suffix)[0];
              } else {
                tempLocationId = `${locationId}${suffix}`;
              }
              document.getElementById(tempLocationId).innerHTML = "";
            } else {
              // current request response have unfilled
              loactionDiv.innerHTML = "";
            }
          }
        }, 2000);
      } else {
        // It will execute when request not from viewability and refresh
        // start old adsence code START

        // check is adsence is already append or not in define slot
        setTimeout(() => {
          let isAlreadyExistsForAdsence = document.getElementById(locationId);
          if (isAlreadyExistsForAdsence.innerHTML == "") {
            // append tag
            document.getElementById(locationId).appendChild(ins);
            // after append tag in location
            (window.adsbygoogle = window.adsbygoogle || []).push({});

            // checking when [data-ad-status] is not avilable
            // setTimeout(() => {
            //     let insSlotId = document.getElementById(locationId).querySelector("ins");
            //     let dataAttribute = insSlotId.getAttribute("data-ad-status");
            //     if (!dataAttribute) {
            //         insSlotId.style.display = `none`;
            //     }
            // }, 5000);
          }
        }, 1000);

        // start old adsence code END
      }
    } else {
      // console.log("Adx step 1 :", locationId);

      let extractAdxBody = adApiDataRes.body_tag.trim();
      let createAdsDiv = document.createElement("div");
      createAdsDiv.innerHTML = extractAdxBody;
      let getAdx = "";
      try {
        getAdx = createAdsDiv.getElementsByTagName("div")[0];
      } catch (error) {}
      if(getAdx){
        getAdx.setAttribute("id", gptAdId); // change adx div id
      }else{
        console.warn("No ad div found", gptAdId)
      }
      // console.log("Adx step 2 :", locationId);
      // make id
      let suffix = "_other";
      if (alternativeDivRequest == true) {
        let locationDivPrevious = document.getElementById(locationId);
        if (locationDivPrevious.innerHTML) {
          let firstChild = locationDivPrevious.firstChild;
          let firstChileInnerHTML = firstChild.innerHTML;
          let display = firstChild.style.getPropertyValue("display");

          if (display == "none") {
            // locationId = `${locationId}`;
            locationDivPrevious.innerHTML = "";
          } else {
            locationId = `${locationId}${suffix}`;
          }
        }

        let isAlreadyExists = document.getElementById(locationId);
        isAlreadyExists.appendChild(getAdx); // append into given id
        try {
          var adxHead = adApiDataRes.head_tag.split("googletag.defineSlot(");
          var adxGtagSlot = adxHead[1].split("',");
          var adxGtagSlotIndex = adxGtagSlot[0].split("'");
          var adxGtagSlotIndexFirst = adxGtagSlotIndex[1]; // googletag.defineSlot
          var adxSlots = adxGtagSlot[1].split(", '"); // ad slots
          var adxSlotsIndex = adxSlots[0];
        } catch (error) {}
        let sloatSizes = JSON.parse(adxSlotsIndex);

        const googletag = (window.googletag = window.googletag || { cmd: [] });
        googletag.cmd.push(function () {
          const responsiveAdSlot1 = googletag
            .defineSlot(adxGtagSlotIndexFirst, sloatSizes, gptAdId)
            .addService(googletag.pubads());
          googletag.pubads().set("page_url", "https://www.seekapeek.com/");
          googletag.pubads().setTargeting("utm_source", utmSource);
          googletag.pubads().collapseEmptyDivs();
          googletag.enableServices();
        });

        googletag.cmd.push(function () {
          googletag.display(gptAdId);
        });

        setTimeout(() => {
          alternativeDivReqHandler(locationId, gptAdId, suffix);
          // collapse Adx ads if not render function
          adxInterscrollerCollpase(locationId, gptAdId);
        }, 2000);
        // }
      } else {
        let isAlreadyExists = document.getElementById(locationId);
        if (isAlreadyExists.innerHTML == "") {
          try {
            isAlreadyExists.appendChild(getAdx); // append into given id
            var adxHead = adApiDataRes.head_tag.split("googletag.defineSlot(");
            var adxGtagSlot = adxHead[1].split("',");
            var adxGtagSlotIndex = adxGtagSlot[0].split("'");
            var adxGtagSlotIndexFirst = adxGtagSlotIndex[1]; // googletag.defineSlot
            var adxSlots = adxGtagSlot[1].split(", '"); // ad slots
            var adxSlotsIndex = adxSlots[0];
            let sloatSizes = JSON.parse(adxSlotsIndex);
        
            const googletag = (window.googletag = window.googletag || {
              cmd: [],
            });
            googletag.cmd.push(function () {
              const responsiveAdSlot1 = googletag
                .defineSlot(adxGtagSlotIndexFirst, sloatSizes, gptAdId)
                .addService(googletag.pubads());
              googletag.pubads().set("page_url", "https://www.seekapeek.com/");
              googletag.pubads().setTargeting("utm_source", utmSource);
              googletag.pubads().collapseEmptyDivs();
              googletag.enableServices();
            });

            googletag.cmd.push(function () {
              googletag.display(gptAdId);
            });
          } catch (error) {}

          setTimeout(() => {
            // alternativeDivRequestHandler funtion
            // alternativeDivReqHandler(locationId, gptAdId, suffix);

            // collapse Adx ads if not render function
            adxInterscrollerCollpase(locationId, gptAdId);
          }, 2000);
        }
      }
    }

    // add margin in bottom when sticky ad render
    setTimeout(() => {
      let stickyAdsDiv = document.getElementById("stickyAds");

      if (stickyAdsDiv) {
        let footerDiv3 = document.getElementById("footer_div_3");
        let listDiv = document.getElementById("list-div");
        if (stickyAdsDiv.offsetHeight > 0) {
          footerDiv3.style.marginBottom = stickyAdsDiv.offsetHeight + "px";
          // listDiv.style.marginBottom = (stickyAdsDiv.offsetHeight) + "px"; // make space in toggal
        }
      }
    }, 2500);
  }
}

const alternativeDivReqHandler = (locationId, gptAdId, suffix) => {
  try {
    let locationIdDiv = document.getElementById(locationId);
    let gptAdIdDiv = document.getElementById(gptAdId);
    let styleAttribute = gptAdIdDiv.style;
    let display = styleAttribute.getPropertyValue("display");

    if (display == "none") {
      locationIdDiv.innerHTML = "";
    } else {
      let tempLocationId = "";
      if (locationId.includes(suffix)) {
        tempLocationId = locationId.split(suffix)[0];
      } else {
        tempLocationId = `${locationId}${suffix}`;
      }
      let curectLocationDiv = document.getElementById(tempLocationId);
      curectLocationDiv.innerHTML = "";
    }
  } catch (error) {
    // console.log("loaction id :" + locationId + " , " + "Gpt Ad Id :" + gptAdId);
  }
};

const adxInterscrollerCollpase = (locationId, gptAdId) => {
  let wrapperDivId = "wrapper_in_" + locationId,
    wrapperDiv = document.getElementById(wrapperDivId),
    locationDiv = document.getElementById(locationId),
    gptDiv = document.getElementById(gptAdId);
  try {
    // If Ad not present by default interscroller height auto.
    // if ad is present we are append height into wrapper.
    // check if ad is interscroller then logic run otherwise skip logic
    if (wrapperDiv) {
      if (!locationDiv.innerHTML == "") {
        if (gptDiv.style.display == "none") {
          // wrapperDiv.style.display = "none";
          wrapperDiv.style.height = "1px";
        } else {
          wrapperDiv.style.height = "300px";
        }
      }
    }
  } catch (error) {}
};

const getCateListData = async () => {
  let langType = localStorage.getItem("language");

  let testingMode = "";
  try {
    testingMode = localStorage.getItem("testingMode");
  } catch (error) {}

  const articlesContent = `${HttpBaseUrl.getBaseUrl()}/homepage/conf/${
    langType ? langType : 1
  }`;
  // const articlesContent = `${process.env.REACT_APP_CDN_BASE_URL}/assets/home_page_conf_${langType ? langType : 1}.json${testingMode == "true" ? "?a=" + Math.random() : ""}`;

  const response = await axios.get(articlesContent, {
    header: headerNoAuth,
  });

  if (response.status == 200) {
    console.log(response);
    
    let CategoryAllDataResult = response.data;

    const randomArray = (shuffleArray) => {
      for (let i = shuffleArray.length - 1; i > 0; i--) {
        let j = Math.floor(Math.random() * (i + 1));
        let temp = shuffleArray[i];
        shuffleArray[i] = shuffleArray[j];
        shuffleArray[j] = temp;
      }
      return shuffleArray;
    };
    // first category data
    randomArray(CategoryAllDataResult.homeCat[0].list);
    var firstCategory = randomArray(CategoryAllDataResult.homeCat[0]);

    // second category data
    randomArray(CategoryAllDataResult.homeCat[1].list);
    var secondCategory = randomArray(CategoryAllDataResult.homeCat[1]);

    // third category data
    randomArray(CategoryAllDataResult.homeCat[2].list);
    var thirdCategory = randomArray(CategoryAllDataResult.homeCat[2]);

    // fourth category data
    randomArray(CategoryAllDataResult.homeCat[3].list);
    var fourthCategory = randomArray(CategoryAllDataResult.homeCat[3]);

    // fifth category data
    randomArray(CategoryAllDataResult.homeCat[4].list);
    var fifthCategory = randomArray(CategoryAllDataResult.homeCat[4]);

    let footerCategoryAll = CategoryAllDataResult.footerCat;
    let headerCategory = CategoryAllDataResult.homeCat;

    let allStatesData = {
      firstCategory: firstCategory,
      secondCategory: secondCategory,
      thirdCategory: thirdCategory,
      fourthCategory: fourthCategory,
      fifthCategory: fifthCategory,
      footerCategoryAll: footerCategoryAll,
      headerCategory: headerCategory,
      adSlots: CategoryAllDataResult,
    };

    return allStatesData;
  }
};
// }

// export default CommonCateState;
export { getCateListData, getLatestPost, adRenderLogic };
